import axios from '@/extensions/axios'
import { js_beautify as jsBeautify } from 'js-beautify'

const getPublishedAt = () => {
  const now = new Date()
  const [ year, month, day, hours, minutes, seconds ] = [now.getFullYear(), now.getMonth() + 1, now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds()]

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

// Layout actions
const actions = {
  async create ({ commit, state }) {
    const { json, ...data } = state.newLayout
    const siteId = this.state.site.active.id

    const { data: createdLayout } = await axios.post('layouts', {
      ...data,
      site_id: siteId
    })

    if (createdLayout.id) {
      return axios.post(`layouts/${createdLayout.id}/content`, {
        json: JSON.parse(json),
        published_at: getPublishedAt()
      }).then(({ data }) => {
        commit('ADD', data)
        commit('CLEAR_NEW')
      })
    }

    return createdLayout
  },

  update ({ commit, state }) {
    try {
      var json = JSON.parse(state.newLayout.json)
    } catch (e) {
      throw new Error('Invalid JSON!')
    }

    var layout = {
      ...state.newLayout,
      json: json
    }

    delete layout.uuid

    axios.put(`layouts/${layout.id}`, layout)

    return axios.post(`layouts/${layout.id}/content`, {
      json,
      published_at: getPublishedAt()
    }).then(({ data }) => {
      commit('UPDATE', data)
    })
  },

  remove ({ commit }, key) {
    return axios.delete('layouts/' + key).then(() => {
      commit('REMOVE', key)
    })
  },

  get ({ commit }, queryParams) {
    return axios.get('layouts', {
      params: queryParams
    }).then((request) => {
      commit('SET', request)
    })
  },

  getById ({ commit }, id) {
    return axios.get('layouts/' + id).then(({ data }) => {
      commit('ADD', data)
      commit('SET_NEW', data.id)
    })
  },

  getRevisionsByLayoutId ({ commit, state }, { id, page }) {
    return axios.get(`layouts/${id}/revisions`, {
      params: {
        page
      }
    }).then((request) => {
      commit('SET_REVISIONS', request)

      if (Array.isArray(request.data) && request.data.length > 0) {
        const revision = request.data.reduce((prev, curr) => {
          if (!curr.published_at || new Date(prev.published_at) > new Date(curr.published_at)) {
            return prev
          }

          return curr
        })

        commit('UPDATE_NEW', { key: 'json',
          value: jsBeautify(
            JSON.stringify(revision.json),
            {
              indent_size: 2
            }
          )
        })

        state.activeRevisionId = revision.id
      }
    })
  }
}

export default actions
